import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import GuestGuard from 'utils/route-guard/GuestGuard';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
const WelcomePage = Loadable(lazy(() => import('pages/auth/Welcome')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/welcome',
          element: (
            <GuestGuard>
              <WelcomePage />
            </GuestGuard>
          )
        },
        {
          path: '/login',
          element: (
            <GuestGuard>
              <LoginPage />
            </GuestGuard>
          )
        },
        {
          path: '/register',
          element: (
            <GuestGuard>
              <RegisterPage />
            </GuestGuard>
          )
        }
      ]
    }
  ]
};

export default LoginRoutes;
